import React from 'react'
import LocationTags from '../../components/locationTags/LocationTags'
import "./locationTagsPage.scss"
const LocationTagsPage = () => {
    return (


        <div className='locationTagsPageContainer'>
            {/* <Sidebar /> */}
            <div className="locationTagsPageTable">
                <LocationTags />
            </div>


        </div>
    )
}

export default LocationTagsPage